var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPakett02ASvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "140px",
    height: "80px",
    viewBox: "0 0 140 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pakett_02a_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pakett_02a",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 4,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 131,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 113,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 95,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 77,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 58,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 40,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 22,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,40 L21.1927573,29.1414164 C22.3220236,28.4281956 23.7327627,28.3256723 24.9532832,28.8681258 L40.5540253,35.801789 C40.8502434,35.9334415 41.12936,36.1006134 41.3852339,36.2996263 L57.2462216,48.6359502 C58.3369271,49.4842767 59.7882284,49.7096001 61.0848055,49.2319138 L76.578897,43.5235643 C77.4945811,43.186207 78.5020048,43.1952241 79.4115035,43.548918 L94.550215,49.4361947 C95.4827223,49.7988365 96.5172777,49.7988365 97.449785,49.4361947 L113.300619,43.2719813 C113.762841,43.0922283 114.254461,43 114.750405,43 L132,43 L132,43",
    id: "Path-14",
    stroke: "#E7A300",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E7A300",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    cx: 132,
    cy: 43,
    r: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPakett02ASvg);
export default __webpack_public_path__ + "static/media/Pakett_02a_SVG.86cf786e1337a2d08a9c27046b5970ec.svg";
export { ForwardRef as ReactComponent };